export interface DownloadItem {
  id: string;
  label: string;
  origins: string[];
  aliases?: string[];
  separateDownload?: boolean;
}

export interface DownloadSubsection {
  id: string;
  label: string;
  items: DownloadItem[];
}

export interface DownloadSection {
  id: string;
  label: string;
  subsections: DownloadSubsection[];
}

export const GROUPED_DOWNLOADS_CONFIG: DownloadSection[] = [

  {
    id: 'cuadre-inversiones',
    label: 'Cuadre de inversiones',
    subsections: [
      {
        id: 'A1',
        label: 'Incurridos Origen',
        items: [
          { id: 'A1.1', label: 'Fichero SAP Incurridos',  origins: ['sap_incurridos_staging'] },
          { id: 'A1.2', label: 'BDR SAP Incurridos',      origins: ['sabana_cuadre_inversiones_incurridos_origen_bdr_sap_incurridos'] },
          { id: 'A1.3', label: 'Duplicados GDA',           origins: ['sap_incurridos_duplicados_fichero_gda'] },
        ],
      },
      {
        id: 'A2',
        label: 'Entradas Inversión',
        items: [
          { id: 'A2.1', label: 'Otros Años', origins: ['sabana_cuadre_inversiones_entradas_inversion_otros_anios'] },
          { id: 'A2.2', label: 'En el Año',  origins: ['sabana_cuadre_inversiones_entradas_inversion_anio'] },
        ],
      },
      {
        id: 'A3',
        label: 'Salidas Inversión',
        items: [
          { id: 'A3.1', label: 'Otros Años', origins: ['sabana_cuadre_inversiones_salidas_inversion_otros_anios'] },
          { id: 'A3.2', label: 'En el Año',  origins: ['sabana_cuadre_inversiones_salidas_inversion_anio'] },
        ],
      },
      {
        id: 'A4',
        label: 'Exclusiones en el Año',
        items: [
          { id: 'A4.1', label: 'Exclusiones en el Año', origins: ['sabana_cuadre_inversiones_exclusiones_anio'] },
        ],
      },
      {
        id: 'A5',
        label: 'Detalle Traspaso - Agregado por Obra',
        items: [
          { id: 'A5.1', label: 'MT/BT',     origins: ['sabana_cuadre_inversiones_detalle_traspaso_agregado_obra_mtbt'] },
          { id: 'A5.2', label: 'Despachos', origins: ['sabana_cuadre_inversiones_detalle_traspaso_agregado_obra_despachos'] },
        ],
      },
      {
        id: 'A6',
        label: 'Agregado por Obra - PCO',
        items: [
          { id: 'A6.1', label: 'MT/BT',     origins: ['sabana_cuadre_inversiones_agregado_obra_pco_mtbt'] },
          { id: 'A6.2', label: 'Despachos', origins: ['sabana_cuadre_inversiones_agregado_obra_pco_despachos'] },
        ],
      },
      {
        id: 'A7',
        label: 'PCO - IID',
        items: [
          { id: 'A7.1', label: 'PCO – IID', origins: ['sabana_cuadre_inversiones_pco_iid'] },
        ],
      },
      {
        id: 'A8',
        label: 'Resumen Entradas y Salidas Inversión',
        items: [
          { id: 'A8.1', label: 'Resumen Entradas y Salidas Inversión', origins: ['sabana_cuadre_inversiones_resumen_entradas_salidas_vista'] },
        ],
      },
      {
        id: 'A9',
        label: 'Seguimiento Inversión en BDR',
        items: [
          { id: 'A9.1', label: 'Seguimiento Inversión en BDR', origins: ['sabana_cuadre_inversiones_seguimiento_inversion_vista'] },
        ],
      },
      {
        id: 'A10',
        label: 'Validaciones',
        items: [
          { id: 'A10.1', label: 'Validaciones',       origins: ['sabana_cuadre_inversiones_validaciones'] },
          { id: 'A10.2', label: 'Validaciones 1 y 2', origins: ['sabana_cuadre_inversiones_validacion_1', 'sabana_cuadre_inversiones_validacion_2'] },
        ],
      },
    ],
  },

  {
    id: 'inversiones',
    label: 'Inversiones',
    subsections: [
      {
        id: 'B1',
        label: 'Detalle Traspaso Incurridos',
        items: [
          { id: 'B1.1', label: 'MT/BT',           origins: ['sabana_inversiones_mtbt_detalle_vista'] },
          { id: 'B1.2', label: 'AT',               origins: ['sabana_inversiones_at_detalle_traspaso_vista'] },
          { id: 'B1.3', label: 'Edificios/Varios', origins: ['sabana_inversiones_edificios_varios_vista'] },
          { id: 'B1.4', label: 'Despachos',        origins: ['sabana_inversiones_despachos_detalle_vista'] },
          { id: 'B1.5', label: 'Equipos de Medida',origins: ['sabana_inversiones_equipos_medida_vista'] },
        ],
      },
      {
        id: 'B2',
        label: 'Agregado por obra',
        items: [
          { id: 'B2.1', label: 'MT/BT',     origins: ['sabana_inversiones_mtbt_agregada_vista'] },
          { id: 'B2.2', label: 'Despachos', origins: ['sabana_inversiones_despachos_agregado_obra_vista'] },
          { id: 'B2.3', label: 'AT',        origins: ['sabana_inversiones_at_traspaso_agregado_vista'] },
        ],
      },
      {
        id: 'B3',
        label: 'Cierre de obra',
        items: [
          { id: 'B3.1', label: 'Instalaciones',    origins: ['sabana_inversiones_cierre_obra_instalaciones_vista'] },
          { id: 'B3.2', label: 'Consulta de APMs', origins: ['maestros_acta_puesta_en_marcha'], aliases: ['actas_puesta_en_marcha'] },
          { id: 'B3.3', label: 'UUCC',             origins: ['sabana_inversiones_cierre_obra_uucc_reparto_con_cantidad_vista'], separateDownload: true },
        ],
      },
    ],
  },

  {
    id: 'inventario',
    label: 'Inventario',
    subsections: [
      {
        id: 'C1',
        label: 'Componente',
        items: [
          { id: 'C1.1',  label: 'CTS (Envolventes)',              origins: ['gdoct_circular_vista'] },
          { id: 'C1.2',  label: 'CTs Sin Servicio',               origins: ['gdoctss_circular_vista'] },
          { id: 'C1.3',  label: 'Interruptores AT',               origins: ['gdointerr_t_circular_vista'] },
          { id: 'C1.4',  label: 'Interruptores MT',               origins: ['gdointerr_circular_vista'] },
          { id: 'C1.5',  label: 'Máquinas de CTs (Trafos de MT)', origins: ['gdotrafo_mb_circular_vista'] },
          { id: 'C1.6',  label: 'Máquinas en Subestación',        origins: ['gdotrafo_pot_circular_vista'] },
          { id: 'C1.7',  label: 'Posiciones en CTs (Celdas)',     origins: ['gdocelda_circular_vista'] },
          { id: 'C1.8',  label: 'Posiciones en subestación',      origins: ['gdoposicion_circular_vista'] },
          { id: 'C1.9',  label: 'Seccionadores AT',               origins: ['gdosecci_t_circular_vista'] },
          { id: 'C1.10', label: 'Seccionadores MT',               origins: ['gdosecci_circular_vista'] },
          { id: 'C1.11', label: 'Seccionadores MT (Sin Servicio)', origins: ['gdosecciss_circular_vista'] },
          { id: 'C1.12', label: 'Subestaciones',                  origins: ['gdosubestac_circular_vista'] },
          { id: 'C1.13', label: 'Tramos AT',                      origins: ['gdotramo_t_circular_vista'] },
          { id: 'C1.14', label: 'Tramos MT',                      origins: ['gdotramo_circular_vista'] },
          { id: 'C1.15', label: 'Tramos MT (Sin Servicio)',        origins: ['gdotramoss_circular_vista'] },
          { id: 'C1.16', label: 'Cuadros de BT',                  origins: ['gdocuadro_baja_circular_vista'] },
          { id: 'C1.17', label: 'Tramos BT',                      origins: ['gdotramo_baja_circular_vista'], separateDownload: true },
        ],
      },
      {
        id: 'C2',
        label: 'Regulatoria',
        items: [
          { id: 'C2.1',  label: 'Centros de Transformación (CTs)', origins: ['gdoct_regulatoria_circular_vista'] },
          { id: 'C2.2',  label: 'Condensadores',                    origins: ['gdobia_condens_regulatoria_circular_vista'] },
          { id: 'C2.3',  label: 'Interruptores MT',                 origins: ['gdointerr_regulatoria_circular_vista'] },
          { id: 'C2.4',  label: 'Máquinas en subestación',          origins: ['gdotrafo_pot_regulatoria_circular_vista'] },
          { id: 'C2.5',  label: 'Posiciones en subestación',        origins: ['gdoposicion_regulatoria_circular_vista'] },
          { id: 'C2.6',  label: 'Reguladores de tensión',           origins: ['gdotraforeg_regulatoria_circular_vista'] },
          { id: 'C2.7',  label: 'Seccionadores AT',                 origins: ['gdosecci_t_regulatoria_circular_vista'] },
          { id: 'C2.8',  label: 'Seccionadores MT',                 origins: ['gdosecci_regulatoria_circular_vista'] },
          { id: 'C2.9',  label: 'Subestaciones',                    origins: ['gdosubestac_regulatoria_circular_vista'] },
          { id: 'C2.10', label: 'Tramos Regulatorios AT',           origins: ['gdotramo_t_regulatoria_circular_vista'] },
          { id: 'C2.11', label: 'Tramos Regulatorios BT',           origins: ['gdotramo_baja_regulatoria_circular_vista'] },
          { id: 'C2.12', label: 'Tramos Regulatorios MT',           origins: ['gdotramo_regulatoria_circular_vista'] },
        ],
      },
    ],
  },

  {
    id: 'informe-instalaciones',
    label: 'Informe de instalaciones declaradas',
    subsections: [
      {
        id: 'D1',
        label: 'Instalaciones',
        items: [
          { id: 'D1.1', label: 'CT',          origins: ['sabana_informe_instalaciones_cts_vista'] },
          { id: 'D1.2', label: 'EMF',         origins: ['sabana_informe_instalaciones_emfs_vista'] },
          { id: 'D1.3', label: 'Tramos MT/BT',origins: ['sabana_informe_instalaciones_tramos_mtbt_vista'] },
        ],
      },
      {
        id: 'D2',
        label: 'Desagrupado',
        items: [
          { id: 'D2.1',  label: 'Agregado Tramos BT',          origins: ['sabana_informe_instalaciones_tramos_bt_agrupados_desagrupado_vista'] },
          { id: 'D2.2',  label: 'CT',                           origins: ['sabana_informe_instalaciones_cts_desagrupado_vista'] },
          { id: 'D2.3',  label: 'Despachos con instalación',   origins: ['sabana_informe_instalaciones_despachos_con_instalacion_vista'] },
          { id: 'D2.4',  label: 'Despachos sin instalación',   origins: ['sabana_informe_instalaciones_despachos_sin_instalacion_vista'] },
          { id: 'D2.5',  label: 'EMF',                          origins: ['sabana_informe_instalaciones_emfs_desagrupado_vista'] },
          { id: 'D2.6',  label: 'Edificios y varios',           origins: ['sabana_informe_instalaciones_edificios_y_varios_vista'] },
          { id: 'D2.7',  label: 'Máquinas',                     origins: ['sabana_informe_instalaciones_maquinas_desagrupado_vista'] },
          { id: 'D2.8',  label: 'Posiciones',                   origins: ['sabana_informe_instalaciones_posiciones_desagrupado_vista'] },
          { id: 'D2.9',  label: 'Tramos AT',                    origins: ['sabana_informe_instalaciones_tramos_at_desagrupado_vista'] },
          { id: 'D2.10', label: 'Tramos MT/BT',                 origins: ['sabana_informe_instalaciones_tramos_mtbt_desagrupado_vista'] },
        ],
      },
      {
        id: 'D3',
        label: 'Comunicaciones',
        items: [
          { id: 'D3.1', label: 'Expedientes MT/BT', origins: ['sabana_informe_comunicaciones_expedientes_mtbt_vista'] },
        ],
      },
    ],
  },

  {
    id: 'formularios',
    label: 'Formularios',
    subsections: [
      {
        id: 'E1',
        label: 'Circular',
        items: [
          { id: 'E1.1',  label: 'F9 AT',          origins: ['f9at_vista'] },
          { id: 'E1.2',  label: 'F9 BT',          origins: ['f9bt_vista'] },
          { id: 'E1.3',  label: 'F9 MT',          origins: ['f9mt_vista'] },
          { id: 'E1.4',  label: 'Formulario 10 AT', origins: ['f10at_vista'] },
          { id: 'E1.5',  label: 'Formulario 10 BT', origins: ['f10bt_vista'] },
          { id: 'E1.6',  label: 'Formulario 10 MT', origins: ['f10mt_vista'] },
          { id: 'E1.7',  label: 'Formulario 11',    origins: ['f11_vista'] },
          { id: 'E1.8',  label: 'Formulario 12',    origins: ['f12_vista'] },
          { id: 'E1.9',  label: 'Formulario 12Bis', origins: ['f12bis_vista'] },
          { id: 'E1.10', label: 'Formulario 13',    origins: ['f13_vista'] },
          { id: 'E1.11', label: 'Formulario 13Bis', origins: ['f13bis_vista'] },
          { id: 'E1.12', label: 'Formulario 13C',   origins: ['f13c_vista'] },
          { id: 'E1.13', label: 'Formulario 14',    origins: ['f14_vista'] },
          { id: 'E1.14', label: 'Formulario 15',    origins: ['f15_vista'] },
          { id: 'E1.15', label: 'Formulario 16',    origins: ['f16_vista'] },
          { id: 'E1.16', label: 'Formulario 17',    origins: ['f17_vista'] },
        ],
      },
      {
        id: 'E2',
        label: 'Inventario',
        items: [
          { id: 'E2.1', label: 'Formulario 1', origins: ['f1_inventario_vista'] },
          { id: 'E2.2', label: 'Formulario 2', origins: ['f2_inventario_vista'] },
          { id: 'E2.3', label: 'Formulario 3', origins: ['f3_inventario_vista'] },
          { id: 'E2.4', label: 'Formulario 4', origins: ['f4_inventario_vista'] },
          { id: 'E2.5', label: 'Formulario 5', origins: ['f5_inventario_vista'] },
          { id: 'E2.6', label: 'Formulario 6', origins: ['f6_inventario_vista'] },
          { id: 'E2.7', label: 'Formulario 7', origins: ['f7_inventario_vista'] },
          { id: 'E2.8', label: 'Formulario 8', origins: ['f8_inventario_vista'] },
        ],
      },
    ],
  },

  {
    id: 'formularios-cnmc',
    label: 'Formularios CNMC',
    subsections: [
      {
        id: 'F1',
        label: 'CNMC A',
        items: [
          { id: 'F1.1', label: 'Formulario A1', origins: ['fa1_vista'] },
          { id: 'F1.2', label: 'Formulario A2', origins: ['fa2_vista'] },
          { id: 'F1.3', label: 'Formulario A3', origins: ['fa3_vista'] },
          { id: 'F1.4', label: 'Formulario A4', origins: ['fa4_vista'] },
          { id: 'F1.5', label: 'Formulario A5', origins: ['fa5_vista'] },
        ],
      },
      {
        id: 'F2',
        label: 'CNMC B',
        items: [
          { id: 'F2.1',  label: 'Formulario B1 AT',   origins: ['fb1at_vista'] },
          { id: 'F2.2',  label: 'Formulario B1 BT',   origins: ['fb1bt_vista'] },
          { id: 'F2.3',  label: 'Formulario B1 MT',   origins: ['fb1mt_vista'] },
          { id: 'F2.4',  label: 'Formulario B1.1 AT', origins: ['fb1_1at_vista'] },
          { id: 'F2.5',  label: 'Formulario B1.1 BT', origins: ['fb1_1bt_vista'] },
          { id: 'F2.6',  label: 'Formulario B1.1 MT', origins: ['fb1_1mt_vista'] },
          { id: 'F2.7',  label: 'Formulario B2',      origins: ['fb2_vista'] },
          { id: 'F2.8',  label: 'Formulario B2.1',    origins: ['fb2_1_vista'] },
          { id: 'F2.9',  label: 'Formulario B2.2',    origins: ['fb2_2_vista'] },
          { id: 'F2.10', label: 'Formulario B3',      origins: ['fb3_vista'] },
          { id: 'F2.11', label: 'Formulario B3.1',    origins: ['fb3_1_vista'] },
          { id: 'F2.12', label: 'Formulario B3.2',    origins: ['fb3_2_vista'] },
          { id: 'F2.13', label: 'Formulario B3.3',    origins: ['fb3_3_vista'] },
          { id: 'F2.14', label: 'Formulario B4',      origins: ['fb4_vista'] },
          { id: 'F2.15', label: 'Formulario B5',      origins: ['fb5_vista'] },
          { id: 'F2.16', label: 'Formulario B6',      origins: ['fb6_vista'] },
          { id: 'F2.17', label: 'Formulario B7 AT/MT',origins: ['fb7atmt_vista'] },
          { id: 'F2.18', label: 'Formulario B7 BT',   origins: ['fb7bt_vista'] },
          { id: 'F2.19', label: 'Formulario B8',      origins: ['fb8_vista'] },
          { id: 'F2.20', label: 'Formulario B9',      origins: ['fb9_vista'] },
        ],
      },
    ],
  },
];
